import { jsx as _jsx } from "react/jsx-runtime";
import { NodeEdgeMapper } from '@iotv/datamodel-core';
import { useMemo } from 'react';
import { AdjacentType } from '../../../types';
import ObjectListCard from '../../../v2/components/generic/ObjectView/ObjectListCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectListCardWidget = (props) => {
    const component = useMemo(() => (_jsx(ObjectListCard, { mostProximateCustomer: props.contextCustomer, adjacentFilter: { adjacentType: AdjacentType.CHILD, objectType: 'User' }, applicationData: new NodeEdgeMapper(), userFunctions: props.userFunctions, transactionFunctions: props.transactionFunctions, viewObject: { matchedPrimary: props.contextCustomer, matchedRelatedByPk: undefined, matchedRelatedBySk: undefined, largeObject: undefined }, listConfigParams: { label: props.contextCustomer?.name ?? props.contextCustomer?.sk ?? '' }, userGroupRoles: undefined })), [props.contextCustomer]);
    return {
        name: 'ObjectListCard',
        category: 'composite',
        component,
    };
};
